import { MERCHANT } from "constants/action-types";
import { Observable } from "rxjs";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import {
    GetMerchantDefaultAllocationDimensionsPreferenceRequestAction,
    getMerchantDefaultAllocationDimensionsPreferenceComplete,
    UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction,
    updateMerchantDefaultAllocationDimensionsPreferenceComplete,
} from "actions/merchant/merchant-default-allocation-dimensions-preference";
import { formatMessage } from "lib/globalize-util";
import { add as snackbarAdd } from "actions/snackbars";
import { updateableMerchantDefaultAllocationDimensionsPreferenceFields } from "constants/merchant";

export const getMerchantDefaultAllocationDimensionsPreferenceEpic = (
    action$: ActionsObservable<GetMerchantDefaultAllocationDimensionsPreferenceRequestAction>
) =>
    action$
        .ofType(MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax(
                `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/default_allocation_dimensions_preference`
            )
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [getMerchantDefaultAllocationDimensionsPreferenceComplete(response.allocation_dimensions)];
                })
                .catch((error) =>
                    Observable.merge(Observable.of(getMerchantDefaultAllocationDimensionsPreferenceComplete(error)))
                );
        });

export const updateMerchantDefaultAllocationDimensionsPreferenceEpic = (
    action$: ActionsObservable<UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction>
) =>
    action$
        .ofType(MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.UPDATE.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, allocation_dimensions }) => {
            // Only save accepted keys
            const updatingData = Object.keys(allocation_dimensions).reduce((acc, key) => {
                if (updateableMerchantDefaultAllocationDimensionsPreferenceFields[key]) {
                    acc[key] = allocation_dimensions[key];
                }
                return acc;
            }, {});
            return ajax({
                method: "PUT",
                url: `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/default_allocation_dimensions_preference`,
                body: {
                    allocation_dimensions: updatingData,
                    update_mask: {
                        paths: Object.keys(updatingData),
                    },
                },
            })
                .flatMap(({ response }) => {
                    return [
                        updateMerchantDefaultAllocationDimensionsPreferenceComplete(response),
                        snackbarAdd({
                            message: formatMessage("Merchant default allocation dimensions preference updated"),
                        }),
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(updateMerchantDefaultAllocationDimensionsPreferenceComplete(error)),
                        Observable.of(snackbarAdd({ message: error.message || formatMessage("Error saving") }))
                    )
                );
        });
